import React from "react";

const Counts = (props: any) => {
  const { data } = props;

  return (
    <div className="row gap-3">
      <div className="box-count col-4 d-flex flex-column align-items-center justify-content-start p-4">
        <span className="f-14 fw-400">Total Revenue</span>
        <span className="f-48 fw-700">
          <span style={{ color: "#8A8A8A" }}>₹</span>
          {data?.data?.totalRevenue}
        </span>
      </div>
      <div className="box-count col-4 d-flex flex-column align-items-center justify-content-start p-4">
        <span className="f-14 fw-400">Patients</span>
        <span className="f-48 fw-700">{data?.data?.patientCount}</span>
      </div>
      <div className="box-count col-3  flex-column d-flex align-items-center justify-content-start p-4">
        <span className="f-14 fw-400">Appointments</span>
        <span className="f-48 fw-700">{data?.data?.appointmentCount}</span>
      </div>
    </div>
  );
};

export default Counts;
